import { ComponentStyleConfig } from '@cloudbeds/payment-sdk';

export const Button: ComponentStyleConfig = {
  baseStyle: {
  },
};
